(function() {
	'use strict';

	angular.module('exportWarehouseApp').controller(
			'StockOutTransferHOController', StockOutTransferHOController);

	StockOutTransferHOController.$inject = [ '$scope', '$filter',
			'NgTableParams', 'FORMAT_DATE', 'StockOutTransferHOService',
			'$uibModal', '$base64', '$window', '$stateParams', '$state',
			'EVENT' ];

	function StockOutTransferHOController($scope, $filter, NgTableParams,
			FORMAT_DATE, StockOutTransferHOService, $uibModal, $base64,
			$window, $stateParams, $state, EVENT) {
		var vm = this;
		var self = $scope;
		var parent = $scope.$parent;

		$scope.format = 'dd/MM/yyyy';
		vm.popupCreateDate = false;
		vm.warehouse = {
			status : 'ALL'
		};
		/*
		 * vm.warehouse.wareHouseName =
		 * parent.appCtrl.account.currentOffice.officeCode + ' - '
		 * +parent.appCtrl.account.currentOffice.officeName;
		 * vm.warehouse.wareHouseCode =
		 * parent.appCtrl.account.currentOffice.officeCode;
		 */

		$scope.dateOptions = {
			minDate : new Date()
		};
		$scope.createDateOptions = {
			maxDate : new Date()
		};
		vm.altInputFormats = [ 'M!/d!/yyyy' ];
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if (event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {
					reload : true
				});
			}
		});

		vm.param = {};

		vm.listProductImport = [];

		vm.warehouse.stockRequestCode = null;

		vm.warehouse.exportDate = new Date();
		vm.wareHouseTable = new NgTableParams(
				{
					page : 1,
					count : 20
				},
				{
					total : 0,
					counts : [],
					defaultSort : 'desc',
					getData : function(params) {
						vm.param.uri = "getTranferHOWarehousing";
						vm.param.page = params.page();
						vm.param.size = params.count();
						vm.param.sort = params.sorting();
						vm.param.tranferHOCode = vm.warehouse.tranferHOCode;
						vm.param.requestTranferHO = vm.warehouse.requestTranferHO;
						vm.param.wareHouseCode = vm.warehouse.wareHouseCode;
						vm.param.transferStockCode = parent.appCtrl.account.currentOffice.officeCode;
						vm.param.status = vm.warehouse.status;
						if (vm.warehouse.createDate != null
								&& vm.warehouse.createDate != '') {
							vm.param.createDate = new Date(
									vm.warehouse.createDate);
						} else {
							vm.param.createDate = null;
						}
						if (vm.warehouse.wareHouseCode != undefined
								&& vm.warehouse.wareHouseCode != null) {
							return StockOutTransferHOService.get(vm.param).$promise
									.then(function(result) {
										params.total(result.totalElements);
										return result.content;
									});
						}
					}
				});

		vm.wareHouseInputTable = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListProductWarehousingTransferHO";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.stockOutId = vm.warehouse.stockOutId;
				vm.param.requestTranferHO = vm.warehouse.requestTranferHO;

				if (vm.warehouse.requestTranferHO != null
						&& vm.warehouse.requestTranferHO != '') {
					return StockOutTransferHOService.query(vm.param).$promise
							.then(function(result) {
								// params.total(total);
								vm.listProductImport = result;
								return result;
							});
				}
			}
		});

		vm.searchProduct = function() {
			vm.wareHouseInputTable.page(1);
			vm.wareHouseInputTable.count(20);
			vm.wareHouseInputTable.total(0);
			vm.wareHouseInputTable.reload();
		};

		vm.search = function() {
			vm.wareHouseTable.page(1);
			vm.wareHouseTable.count(20);
			vm.wareHouseTable.total(0);
			vm.wareHouseTable.reload();
		};

		vm.openDatePicker = function() {
			vm.popupCreateDate = true;
		};

		vm.openPopup = function(stockOutId, typeProcess) {
			var link = GLOBAL_URL + 'stockout/#/createStockOutTransferHO' + '/'
					+ $base64.encode(typeProcess);
			if (stockOutId !== null) {
				link = link + '/' + $base64.encode(stockOutId);
			}
			$window.open(link, '_self');
		};

		vm.isCreate = false;
		vm.isView = false;
		vm.isAdjust = false;
		vm.isExit = false;
		vm.checkMultiSubmit = 0;
		vm.initPage = function() {
			vm.checkMultiSubmit = 0;
			vm.warehouse.createDate = new Date();
			vm.warehouse.createUser = parent.appCtrl.account.fullName;
			vm.warehouse.departmentRequest = parent.appCtrl.account.department;
			var typeProcess = $base64.decode($stateParams.typeProcess);
			vm.getListStock(2);
			if ($stateParams.stockOutId != null) {
				vm.warehouse.stockOutId = $base64
						.decode($stateParams.stockOutId);
				vm.getExportInfoDetail();
			}
			for (var i = 0; i < listTypeProcessTransferHO.length; i++) {
				if (typeProcess == listTypeProcessTransferHO[i].code) {
					vm.title = listTypeProcessTransferHO[i].name;
					if (i == 0) { // create
						vm.isCreate = true;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = false;
						vm.getListRequestTranfer();
					} else if (i == 1) { // view
						vm.isCreate = false;
						vm.isView = true;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 2) { // adjust
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = true;
						vm.isExit = false;
					} else if (i == 3) { // exit
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = true;
					}
					break;
				}
			}
		};

		vm.exit = function() {
			var link = GLOBAL_URL + 'stockout/#/stockOutTransferHO';
			$window.open(link, '_self');
		};

		vm.getListRequestTranfer = function() {
			StockOutTransferHOService
					.query(
							{
								uri : 'getListRequestTranfer',
								wareHouseCode : parent.appCtrl.account.currentOffice.officeCode
							},
							function(result) {
								vm.warehouse.listRequestTranferHO = result;
								if (vm.warehouse.listRequestTranferHO !== null
										&& vm.warehouse.listRequestTranferHO.length > 0) {
									vm.warehouse.requestTranferHO = vm.warehouse.listRequestTranferHO[0].name;
									vm.getListProductTranfer();
								}
							});
		};

		vm.getListProductTranfer = function() {
			StockOutTransferHOService.get({
				uri : 'getListProductTranfer',
				requestTranferHO : vm.warehouse.requestTranferHO
			}, function(result) {
				if (result != null) {
					vm.warehouse.tranferHOCode = result.stockOutCode;
					vm.warehouse.stockRequest = result.requestStockCode + ' - '
							+ result.requestStockName;
					vm.warehouse.stockRequestCode = result.requestStockCode;
					vm.warehouse.cancelReason = result.cancelReason;
					vm.warehouse.wareHouseCode = result.tranStockCode;
				}
			});
			vm.searchProduct();
		};

		vm.save = function() {

			for (var i = 0, size = vm.listProductImport.length; i < size; i++) {
				var series = vm.listProductImport[i];
				var seriesIndicator = vm.listProductImport[i].seriesIndicator;
				var quantity = 0;
				for (var j = 0, length = series.listSeries.length; j < length; j++) {
					var seriesDTO = series.listSeries[j];
					if (seriesIndicator == 1) {
						if (seriesDTO.seriesFrom == null
								|| seriesDTO.seriesFrom == 0) {
							self
									.addAlert('Từ số seri bắt buộc nhập.',
											'danger');
							return;
						}
						if (seriesDTO.seriesTo == null
								|| seriesDTO.seriesTo == 0) {
							self.addAlert('Đến số seri bắt buộc nhập.',
									'danger');
							return;
						}
					}
					if (seriesDTO.seriesFrom != null
							&& seriesDTO.seriesTo != null
							&& seriesDTO.seriesFrom != ''
							&& seriesDTO.seriesTo != '') {
						if (parseInt(seriesDTO.seriesFrom) > parseInt(seriesDTO.seriesTo)) {
							self.addAlert(
									'Từ số seri phải lớn hơn đến số seri.',
									'danger');
							return;
						}
						var minusSeries = parseInt(seriesDTO.seriesTo)
								- parseInt(seriesDTO.seriesFrom) + 1;
						quantity += minusSeries;
					}
				}
				if (seriesIndicator == 1
						&& quantity != parseInt(series.approvalQuantity)) {
					self
							.addAlert(
									'Số seri không bằng số lượng nhập, vui lòng xem lại!',
									'danger');
					return;
				}
			}
			vm.checkMultiSubmit = vm.checkMultiSubmit + 1;
			self.loading = true;
			if (vm.checkMultiSubmit == 1) {
				StockOutTransferHOService.post({
					uri : 'saveStockTranfer',
					stockRequestCode : vm.warehouse.wareHouseCode,
					exportDate : vm.warehouse.exportDate
				}, vm.listProductImport, function(result) {
					$(window).scrollTop(0);
					self.loading = false;
					// if (result.messages.length == 0) {
					self.addAlert('Thao tác thành công!', 'success');
					vm.exit();
					// }
				}, function(error) {
					if(error.status == '403') {
						$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
					}
					self.loading = false;
				});
			}
		};

		vm.cancel = function() {
			self.loading = true;
			StockOutTransferHOService
					.returnValue(
							{
								uri : 'cancelStockOut',
								cancelReason : vm.warehouse.cancelReason,
								stockOutId : vm.warehouse.stockOutId
							},
							function(result) {
								$(window).scrollTop(0);
								self.loading = false;
								if (result.response == -1) {
									self
											.addAlert(
													'Phiếu nhập kho này không thể hủy do sản phẩm đã được cấp phát!',
													'danger');
								} else {
									self.addAlert('Thao tác thành công!',
											'success');
								}
								vm.exit();
							}, function() {
								self.loading = false;
							});
		};

		vm.getExportInfoDetail = function() {
			self.loading = true;
			if (vm.warehouse.stockOutId != null
					&& vm.warehouse.stockOutId != '') {
				StockOutTransferHOService.get({
					uri : 'getExportInfoDetail',
					stockOutId : vm.warehouse.stockOutId
				}, function(result) {
					vm.warehouse.tranferHOCode = result.tranferHOCode;
					vm.warehouse.requestTranferHO = result.requestTranferHO;
					vm.warehouse.createDate = new Date(result.createDate);
					vm.warehouse.createUser = result.createUser;
					vm.warehouse.stockRequest = result.stockRequestCode + ' - '
							+ result.stockRequestName;
					vm.warehouse.cancelReason = result.cancelReason;
					if (result.cancelReason != null
							&& result.cancelReason != '') {
						vm.showCancelReason = true;
					}
					vm.warehouse.exportDate = new Date(result.exportDate);
					vm.warehouse.owner = result.owner;
					self.loading = false;
				}, function() {
					self.loading = false;
				}).$promise.then(function(result) {
					vm.wareHouseInputTable.page(1);
					vm.wareHouseInputTable.count(20);
					vm.wareHouseInputTable.total(0);
					vm.wareHouseInputTable.reload();
				});
			}
		};

		vm.getListStock = function(typeView) {
			StockOutTransferHOService
					.query(
							{
								uri : 'getListStock',
								type : '1',
								officeCode : parent.appCtrl.account.currentOffice.officeCode
							},
							function(result) {
								vm.warehouse.listWarehouse = result;
								if (result.length > 0) {
									vm.warehouse.wareHouseCode = result[0].code;
								} else {
									self
											.addAlert(
													'Văn phòng này không được phép thao tác chức năng này',
													'danger');
								}
							}).$promise.then(function(result) {
				if (typeView == 1) {
					vm.search();
					// vm.wareHouseTable.reload();
					/*
					 * } else if(typeView == 2) { vm.getListRequestTranfer();
					 */
				}
			});
		};

		vm.getListStockExcluded = function(typeView) {
			StockOutTransferHOService.query({
				uri : 'getListStockExcluded',
				type : '1',
				officeCode : parent.appCtrl.account.currentOffice.officeCode
			}, function(result) {
				vm.warehouse.listWarehouse = result;
				if (result.length > 0) {
					vm.warehouse.wareHouseCode = result[0].code;
					/*
					 * } else { self.addAlert('Văn phòng này không được phép
					 * thao tác chức năng này', 'danger');
					 */
				}
			}).$promise.then(function(result) {
				if (typeView == 1) {
					vm.search();
				}
			});
		};

		vm.init = function() {
			vm.getListStockExcluded(1);
		};
	}
})();
